import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupModule, PopupComponent } from '@progress/kendo-angular-popup';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { CardModule } from '@progress/kendo-angular-layout';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [CommonModule, PopupModule, ButtonModule, CardModule],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent {
  @ViewChild('anchor') anchor!: ElementRef;
  @ViewChild('popup') popup!: PopupComponent;

  @Input() userFullName = '';
  @Input() userEmail = '';
  @Input() userPhoto: string | null = null;
  @Input() userInitials = 'U';

  @Output() accountClick = new EventEmitter<void>();
  @Output() logoutClick = new EventEmitter<void>();

  isMenuOpen = false;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  onAccountClick(): void {
    this.closeMenu();
    this.accountClick.emit();
  }

  onLogoutClick(): void {
    this.closeMenu();
    this.logoutClick.emit();
  }
}
